import { useContext, useEffect } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { useGetQuotaAvailability } from '@/hooks/useGetQuotaAvailability'

export default function QuotaAvailability() {
  const { watch, setValue } = useContext<CustomComponentContextType>(CustomComponentContext)
  const timeoff: string | undefined = watch('TIMEOFF_TYPE')
  const employeeName: number | undefined = watch('EMPLOYEE_NAME')

  const { mutate, data: quotaAvailability } = useGetQuotaAvailability()

  useEffect(() => {
    if (timeoff !== undefined && employeeName !== undefined) {
      mutate({
        employeeId: employeeName,
        timeOffId: splitTimeOff(timeoff).timeOffId,
      })
    }
  }, [timeoff, employeeName])

  useEffect(() => {
    if (timeoff !== undefined) {
      setValue('TIMEOFF_NAME', splitTimeOff(timeoff).timeOffName)
      setValue('TIMEOFF_TYPE_ID', splitTimeOff(timeoff).timeOffId)
    }
  }, [timeoff])

  function splitTimeOff(timeOff: string): {
    timeOffId: number
    timeOffName: string
  } {
    const timeOffArray = timeOff.split('|')
    const timeOffId = parseInt(timeOffArray[0])
    const timeOffName = timeOffArray[1]

    return {
      timeOffId,
      timeOffName,
    }
  }

  return (
    <>
      {quotaAvailability && (
        <>
          Jumlah Kuota Tersedia: {quotaAvailability.number_of_hours} Jam ({quotaAvailability.number_of_days} Hari)
        </>
      )}
    </>
  )
}
